// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TxZ1","rootMobile":"styles_rootMobile__21A9K"};